import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { FuseNavigationService } from '@fuse/components/navigation';
import { Project } from 'app/core/defs/project';

// Actions
import { loadProjects } from 'app/store/projects/projects.actions';
import { loadPricingInfo } from 'app/store/pricing/pricing.actions';

// Selectors
import { selectAllProjects } from 'app/store/projects/projects.selectors';
import { selectDeveloperPlanId } from 'app/store/pricing/pricing.selectors';

@Component({
	selector: 'app-project-switcher',
	templateUrl: './project-switcher.component.html',
	styleUrls: ['./project-switcher.component.scss'],
})
export class ProjectSwitcherComponent implements OnInit {
	projects$: Observable<Project[]>;
	bottomSheetItems$: Observable<any[]>;
	selectedProject: Project;

	constructor(
		private router: Router,
		private store: Store,
		private fuseNavigationService: FuseNavigationService,
	) {
		// Combine projects and developer plan to filter projects based on plan
		this.projects$ = combineLatest([
			this.store.select(selectAllProjects),
			this.store.select(selectDeveloperPlanId)
		]).pipe(
			map(([projects, planId]) => {
				switch (planId) {
					case 'starter':
						return projects.slice(0, 1);
					case 'studio':
						return projects.slice(0, 2);
					default:
						return projects;
				}
			})
		);

		// Transform projects into bottom sheet items
		this.bottomSheetItems$ = this.projects$.pipe(
			map(projects => projects.map(({ name }) => ({
				value: name,
				viewValue: name,
			})))
		);

		// Set selected project based on navigation service
		this.projects$.subscribe(projects => {
			this.selectedProject = projects.find(
				(project: Project) => this.fuseNavigationService.projectId === project.id
			);
		});
	}

	ngOnInit(): void {
		// Dispatch actions to load initial data
		this.store.dispatch(loadProjects());
		this.store.dispatch(loadPricingInfo());
	}

	onProjectChange(project: Project): void {
		if (project) {
			this.router.navigate(['/project', project.id, 'overview']);
			this.fuseNavigationService.projectId = project.id;
		}
	}

	compareObjects(o1: Project, o2: Project): boolean {
		return o1?.name === o2?.name && o1?.id === o2?.id;
	}
}
